import { render, staticRenderFns } from "./esportsTournamentList.vue?vue&type=template&id=3c5c2c1b&"
import script from "./esportsTournamentList.vue?vue&type=script&lang=js&"
export * from "./esportsTournamentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports